import {
  IEmployeeTimeOffActions,
  EmployeeTimeOffContext,
  IEmployeeTimeOffBalanceFetchPayload
} from './actions.types';
import {
  IEmployeeTimeOffBookingBalanceData,
  IEmployeeTimeOffData
} from '@/models';
import {
  ICreateMultipleEmployeeTimeOffEntitlementsPayload,
  IFetchEmployeeTimeOffEntitlementsPayload
} from '@/services';

export const actions: IEmployeeTimeOffActions = {
  fetchEmployeeTimeOff(
    context: EmployeeTimeOffContext,
    payload: number
  ): Promise<void> {
    return this.$services.employeeTimeOff
      .fetchEmployeeTimeOff(payload)
      .then(employeeTimeOff => {
        context.commit('SET_EMPLOYEE_TIME_OFF_REQUEST', employeeTimeOff);
      });
  },

  fetchEmployeeTimeOffBalance(
    context: EmployeeTimeOffContext,
    payload: IEmployeeTimeOffBalanceFetchPayload
  ): Promise<IEmployeeTimeOffBookingBalanceData> {
    return this.$services.employeeTimeOff
      .fetchEmployeeTimeOffBalance(payload.employee, payload.year)
      .then(employeeTimeOffBalance => {
        context.commit(
          'SET_EMPLOYEE_TIME_OFF_REQUEST_BALANCES',
          employeeTimeOffBalance
        );
        return employeeTimeOffBalance;
      });
  },

  updateEmployeeTimeOff(
    context: EmployeeTimeOffContext,
    payload: IEmployeeTimeOffData
  ): Promise<void> {
    return this.$services.employeeTimeOff
      .updateEmployeeTimeOff(payload)
      .then(employeeTimeOff => {
        context.commit('SET_EMPLOYEE_TIME_OFF_REQUEST', employeeTimeOff);
      });
  },

  createMultipleEmployeeTimeOffEntitlements(
    context: EmployeeTimeOffContext,
    payload: ICreateMultipleEmployeeTimeOffEntitlementsPayload
  ): Promise<void> {
    return this.$services.employeeTimeOff
      .createMultipleEmployeeTimeOffEntitlements(payload)
      .then(data => {
        context.commit('SET_EMPLOYEE_TIME_OFF_REQUEST_ENTITLEMENTS', data);
      });
  },

  fetchEmployeeTimeOffEntitlements(
    context: EmployeeTimeOffContext,
    payload: IFetchEmployeeTimeOffEntitlementsPayload
  ): Promise<void> {
    return this.$services.employeeTimeOff
      .fetchEmployeeTimeOffEntitlements(payload)
      .then(data => {
        context.commit('SET_EMPLOYEE_TIME_OFF_REQUEST_ENTITLEMENTS', data);
      });
  },

  fetchEmployeeTimeOffEntitlementYears(
    context: EmployeeTimeOffContext,
    payload: number
  ): Promise<void> {
    return this.$services.employeeTimeOff
      .fetchEmployeeTimeOffEntitlementYears(payload)
      .then(data => {
        context.commit('SET_EMPLOYEE_TIME_OFF_REQUEST_ENTITLEMENT_YEARS', data);
      });
  },

  fetchEmployeeTimeOffEntitlementVacationYear(
    context: EmployeeTimeOffContext,
    payload: number
  ): Promise<void> {
    return this.$services.employeeTimeOff
      .fetchEmployeeTimeOffEntitlementVacationYear(payload)
      .then(data => {
        context.commit(
          'SET_EMPLOYEE_TIME_OFF_REQUEST_ENTITLEMENT_VACATION_YEAR',
          data
        );
      });
  }
};
